import { FC, useState, createContext } from 'react';
import { EnrolledSubject } from 'src/models/enrolledSubject.interface';
import { getEnrolledSubjectByStudent } from 'src/services/Student/subject.service';

type EnrolledSubjectContext = {
  contextEnrolledSubjects: any;
  getContextEnrolledSubjects: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrolledSubjectContext = createContext<EnrolledSubjectContext>(
  {} as EnrolledSubjectContext
);

export const EnrolledSubjectProvider: FC = ({ children }) => {
  const [contextEnrolledSubjects, setContextEnrolledSubjects] =
    useState<EnrolledSubject[]>();

  const getContextEnrolledSubjects = async () => {
    setTimeout(() => {
      getEnrolledSubjectByStudent().then((response: any) => {
        setContextEnrolledSubjects(response.data);
      });
    }, 100);
  };

  return (
    <EnrolledSubjectContext.Provider
      value={{ contextEnrolledSubjects, getContextEnrolledSubjects }}
    >
      {children}
    </EnrolledSubjectContext.Provider>
  );
};
